import { Content } from './content.aggregate';

export const contentService = {
  createContent: (content: Content): Content => {
    return Object.freeze({
      id: content.id,
      kind: content.kind,
      name: content.name,
      nameLanguage: content.nameLanguage,
      url: content.url,
      thumbnailUrl: content.thumbnailUrl
    });
  }
};
